import { extendTailwindMerge } from 'tailwind-merge';

// Prevent twMerge from overwriting font sizes with colors
// see @https://github.com/dcastil/tailwind-merge/blob/v1.13.2/docs/configuration.md
const customTwMerge = extendTailwindMerge({
  extend: {
    classGroups: {
      'font-size': [
        {
          text: [
            'xs',
            'sm',
            'md',
            'lg',
            'xl',
            'display-xs',
            'display-sm',
            'display-md',
            'display-lg',
            'display-xl',
            'display-2xl',
            'overline-sm',
            'overline-md',
            'overline-lg',
          ],
        },
      ],
    },
  },
});

export default customTwMerge;
